import { render, staticRenderFns } from "./SuspendForm.vue?vue&type=template&id=4cb364c6"
import script from "./SuspendForm.vue?vue&type=script&lang=js"
export * from "./SuspendForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports